/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { v4 } from "uuid";
import { Button } from "@nordcloud/gnui";
import { Prerequisite } from "~/models/prerequisite";

type PrerequisitesProps = {
  list: Prerequisite[];
  setList: React.Dispatch<React.SetStateAction<Prerequisite[]>>;
};

function AddPrerequisites({ list, setList }: PrerequisitesProps) {
  const checkIsEmpty = list?.filter((r: Prerequisite) => r.text.length === 0)
    ?.length;

  return (
    <Button
      css={{ marginBottom: "0.5rem", marginLeft: "auto" }}
      size="md"
      severity="medium"
      icon="plus"
      disabled={checkIsEmpty !== 0}
      onClick={() => {
        setList([...list, { id: v4(), text: "" }]);
      }}
    >
      Add Prerequisites
    </Button>
  );
}

export { AddPrerequisites };
